/**
 * Every spoken sentence gets a short, stable key made from its text, so the site can
 * find the matching pre-recorded clip (public/assets/voice/<key>.mp3) without a lookup table.
 * Change the words and the key changes too, so an old recording is never played for new text.
 */
export function normalizeSpeechText(text) {
  return text.replace(/\s+/g, ' ').trim();
}

// cyrb53: a small, fast 53-bit string hash. Plenty to keep a few thousand lines apart.
function hashText(text) {
  let first = 0xdeadbeef;
  let second = 0x41c6ce57;
  for (let index = 0; index < text.length; index++) {
    const code = text.charCodeAt(index);
    first = Math.imul(first ^ code, 2654435761);
    second = Math.imul(second ^ code, 1597334677);
  }
  first = Math.imul(first ^ (first >>> 16), 2246822507) ^ Math.imul(second ^ (second >>> 13), 3266489909);
  second = Math.imul(second ^ (second >>> 16), 2246822507) ^ Math.imul(first ^ (first >>> 13), 3266489909);
  return 4294967296 * (2097151 & second) + (first >>> 0);
}

export function createVoiceClipKey(text) {
  return hashText(normalizeSpeechText(text)).toString(36);
}
